document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.care-icons-wrapper');

  wrappers.forEach(wrapper => {
    const max      = parseInt(wrapper.dataset.max, 10);
    const buttons  = wrapper.querySelectorAll('.care-icon-option');
    const display  = wrapper.querySelector('.care-icons-selected');
    const input    = wrapper.querySelector('#CareIconsInput');
    const counter  = wrapper.querySelector('#care-icons-counter');

    const selectedIcons = [];
    const sortableEnabled = typeof Sortable !== 'undefined';

    /* ---------- click to select / deselect ---------- */
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const code  = btn.dataset.name;
        const index = selectedIcons.findIndex(i => i.code === code);

        if (index > -1) {
          selectedIcons.splice(index, 1);
          btn.setAttribute('aria-pressed', 'false');
        } else {
          if (selectedIcons.length >= max) return;
          selectedIcons.push({ code, button: btn });
          btn.setAttribute('aria-pressed', 'true');
        }

        updateDisplay();
      });
    });

    /* ---------- main UI refresh ---------- */
    function updateDisplay() {
      display.innerHTML = '';

      selectedIcons.forEach(icon => {
        const clone = icon.button.cloneNode(true);
        clone.removeAttribute('aria-pressed');
        clone.setAttribute('data-code', icon.code);
        display.appendChild(clone);
      });

      // Drag message
      if (sortableEnabled && selectedIcons.length > 1) {
        const tip = document.createElement('p');
        tip.textContent = 'Drag your icons to rearrange';
        tip.className = 'text-xs mt-2 mb-2 drag-instructions';
        display.appendChild(tip);
      }

      input.value = selectedIcons.map(i => i.code).join(', ');
      if (counter) counter.textContent = `${selectedIcons.length}/${max} selected`;

      buttons.forEach(btn => {
        const isSelected = selectedIcons.some(i => i.code === btn.dataset.name);
        if (!isSelected && selectedIcons.length >= max) {
          btn.disabled = true;
          btn.classList.add('disabled');
        } else {
          btn.disabled = false;
          btn.classList.remove('disabled');
        }
      });
    }

    /* ---------- drag‑and‑drop sorting ---------- */
    if (sortableEnabled) {
      Sortable.create(display, {
        animation: 150,
        onEnd: () => {
          const newOrder = Array.from(display.querySelectorAll('[data-code]')).map(el => el.dataset.code);
          selectedIcons.sort((a, b) => newOrder.indexOf(a.code) - newOrder.indexOf(b.code));
          updateDisplay();
        }
      });
    } else {
      console.warn('SortableJS not loaded. Drag‑and‑drop will not work.');
    }

    updateDisplay();
  });
});
